import ArticleTemplate from "../components/ArticleTemplate";
import { articles } from "@/mocks/articles";

export default function ArticleVsSuperbuy() {
  return <ArticleTemplate article={articles[7]} />;
}